<template>
  <v-card
    flat
    tile
  >
    <v-card-text>
      <v-row class=" text-center">
        <v-col cols="12">
          <copy-url :store-id="storeId" />
        </v-col>
        <v-col cols="12">
          <contactless-form
            :account-id="accountId"
            :store-id="storeId"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import CopyUrl from "./CopyURL";
import ContactlessForm from "./ContactlessForm";

export default {
  name: "ContactlessStore",
  components: {
    CopyUrl,
    ContactlessForm
  },
  data() {
    return {
      accountId: parseInt(this.$route.params.accountId),
      storeId: parseInt(this.$route.params.storeId)
    };
  }
};
</script>